export default __webpack_public_path__ + "static/media/carpediembes4.354159fd.jpg";